import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { images } from "../../utils/images";

function BusinessDetails(props) {
  const { t, classes } = props;

  const [businessName, setBusinessName] = useState("");
  const [businessNumber, setBusinessNumber] = useState("");
  const [businessNature, setBusinessNature] = useState("");
  const [businessWebsite, setBusinessWebsite] = useState("");
  const [isValidUrl, setValidUrl] = useState(null);

  const [missingFields, setMissingFields] = useState([]);

  const stepInputs = [
    {
      id: "name",
      label: "_businessName",
      modifier: setBusinessName,
      value: businessName,
      placeholder: null,
    },
    {
      id: "registration_number",
      label: "_registrationNumber",
      modifier: setBusinessNumber,
      value: businessNumber,
      placeholder: null,
    },
    {
      id: "nature",
      label: "_natureOfActivity",
      modifier: setBusinessNature,
      value: businessNature,
      placeholder: null,
    },
    {
      id: "website_url",
      label: "_businessWebsite",
      modifier: setBusinessWebsite,
      value: businessWebsite,
      placeholder: "_exampleUrl",
    },
  ];

  const validateUrl = () => {
    let expUrl =
      "(https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9]+.[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,})";
    let regex = new RegExp(expUrl);

    if (businessWebsite.match(regex)) {
      console.log("VALIED");
      setValidUrl(true);
    } else {
      console.log("NO VALIED");
      setValidUrl(false);
      setMissingFields(["website_url"]);
    }
  };

  const validateBusinessDataAndProceed = () => {
    let businessDetails = {
      name: businessName.trim(),
      registration_number: businessNumber.trim(),
      nature: businessNature.trim(),
      website_url: businessWebsite.trim(),
    };

    let missingFields = [];

    Object.keys(businessDetails).map((k) => {
      if (businessDetails[k] === "") {
        missingFields.push(k);
      }
    });

    if (missingFields.length) {
      setMissingFields(missingFields);
      return props.pushNotification({
        message: "missingFields",
        type: "error",
      });
    }

    props.setBusinessDetails(businessDetails);
    props.moveForward();
  };

  return (
    <div className="corporateStepContainer">
      <h2 dangerouslySetInnerHTML={{ __html: t("_corporateT1") }} />
      <p>{t("_corporateP1")}</p>
      <div className={`inputsContainer ${classes.inputRows}`}>
        <div className="left">
          {stepInputs.map((i) => {
            return (
              <div className="inputRow" key={i.id}>
                <p className="label">{t(i.label)}</p>
                <input
                  type="text"
                  onChange={(e) => i.modifier(e.target.value)}
                  value={i.value}
                  className={missingFields.includes(i.id) ? "invalidField" : ""}
                  onBlur={
                    i.id === "website_url" ? () => validateUrl() : () => {}
                  }
                  placeholder={i.placeholder ? t(i.placeholder) : ""}
                />
                {i.id === "website_url" ? (
                  isValidUrl === false ? (
                    <p className={classes.invalidUrlMsg}>
                      {t("_invalidUrlFormat")}
                    </p>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
        <div className="right">
          <img src={images.illustrations.corpSolo1} />
        </div>
      </div>
      <div className="nextButtonContainer">
        <button
          disabled={isValidUrl ? false : true}
          onClick={() => validateBusinessDataAndProceed()}
        >
          {t("next")}
        </button>
      </div>
    </div>
  );
}

const styles = (theme) => ({
  invalidUrlMsg: {
    color: `${theme.colors.buttons.sell} !important`,
  },
  inputRows: {
    "& .inputRow": {
      marginBottom: 16,

      "& .label": {
        fontSize: 14,
        color: theme.colors.text.secondary,
        marginBottom: 8,
      },
      "& input": {
        ...theme.defaults.input,
        maxWidth: "none",
        "&.invalidField": {
          borderColor: theme.colors.buttons.sell,
        },
      },
    },
  },
});

export default withStyles(styles)(withTranslation()(BusinessDetails));
